<template>
	<v-container fluid class="pa-0 background darken-1">
		<v-container class="pa-2 background darken-1" grid-list-xs>
			<v-layout>
				<v-flex shrink>
					<v-text-field
						solo
						name="OF"
						:rules="[]"
						style="width: 300px"
						:loading="loading_of"
						class="mb-3 grv-input mr-1"
						type="number"
						clearable
						:messages="[input_message]"
						v-model.number="num_of">
						<template v-slot:prepend-inner>
							OF
						</template>
						<template v-slot:append>
							<v-btn
								class="mx-0"
								flat icon
								color="primary"
								:disabled="!num_of"
								@click="num_of--">
								<v-icon>chevron_left</v-icon>
							</v-btn>
							<v-btn
								class="mx-0"
								flat icon
								color="primary"
								:disabled="!num_of"
								@click="num_of++">
								<v-icon>chevron_right</v-icon>
							</v-btn>
						</template>
					</v-text-field>
				</v-flex>
			</v-layout>

			<div v-if="computed_data">
				<div class="mb-4">
					<div style="display: flex; align-items: center" class="mb-1">
						<span class="headline">
							COMMANDE
							{{ computed_data.commande.id }}
						</span>
						<v-chip small outline color="white" class="my-0 mx-2">
							{{ computed_data.commande.status }}
						</v-chip>
						Créé le {{ computed_data.creation_date | formatDateNoTime }}
					</div>
					<div>
						Suivi par
						<span class="subheading">
							{{ computed_data.cdc.login }}
						</span>
						<span class="caption">
							({{ computed_data.cdc.name | capitalize }})
						</span>
					</div>
					<div>
						Client:
						<span class="subheading">
							{{ computed_data.customer }}
						</span>
					</div>
				</div>

				<div class="mb-4">
					<div style="display: flex; align-items: center" class="mb-1">
						<span class="headline">
							OF
							{{ computed_data.of.id }}
						</span>
						<v-chip small outline color="white" class="my-0 mx-2">
							{{ computed_data.of.status }}
						</v-chip>
						Délai: {{ computed_data.due_date | formatDateNoTime }}
					</div>
					<div class="subheading">
						{{ computed_data.title.princ }}
						<a
							:href="`${behive_url}dashboard/title/${computed_data.title.id}/`"
							class="ml-2"
							target="_blank">
							BeHive
						</a>
					</div>
					<div class="subheading background--text text--lighten-5">
						{{ computed_data.title.sec }}
					</div>
				</div>

				<v-layout>
					<v-flex xs6 class="pr-1">
						<div class="headline mb-1">
							ASSETS
						</div>
						<v-btn
							v-if="!is_detail_page && selected_fab"
							block
							color="blue"
							class="text-none"
							@click="emitAssets()">
							<v-icon class="mr-2">subscriptions</v-icon>
							Utiliser les assets sources
						</v-btn>
						<v-expansion-panel class="assets-panels" expand>
							<v-expansion-panel-content></v-expansion-panel-content>
							<v-expansion-panel-content
								v-for="(asset, asset_id) in computed_data.assets"
								:key="asset_id"
								class="asset-panel elevation-4"
								:class="computeAssetIOClass(asset)">
								<div slot="header" class="expansion-header-dynamic">
									<div class="dynamic-col" v-if="selected_fab"
										:style="{
											'min-width': '50px',
											'max-width': '50px'
										}">
										<span
											v-if="asset.source_of_fab.indexOf(selected_fab) > -1"
											class="ml-1 blue--text">
											SRC
										</span>
										<span
											v-if="asset.record_of_fab.indexOf(selected_fab) > -1"
											class="ml-1 green--text text--accent-3">
											REC
										</span>
									</div>
									<div
										class="dynamic-col"
										:style="{
											'min-width': asset_col_widths.type_sup + 'px',
											'max-width': asset_col_widths.type_sup + 'px'
										}">
										<v-tooltip bottom color="background">
											<template v-slot:activator="{ on }">
												<span v-on="on">
													{{ asset.type_sup.code }}
												</span>
											</template>
											<span>{{ asset.type_sup.label }}</span>
										</v-tooltip>
									</div>
									<div
										class="dynamic-col"
										:style="{
											'min-width': '88px',
											'max-width': '88px'
										}">
										{{ asset.ref_materiel }}
									</div>
									<div class="dynamic-col"
										:style="{
											'min-width': asset_col_widths.norme + 'px',
											'max-width': asset_col_widths.norme + 'px'
										}">
										<v-tooltip bottom color="background">
											<template v-slot:activator="{ on }">
												<span v-on="on">
													{{ asset.norme.code }}
												</span>
											</template>
											<span>{{ asset.norme.label }}</span>
										</v-tooltip>
									</div>
									<div class="dynamic-col"
										:style="{
											'min-width': '76px',
											'max-width': '76px'
										}">
										<span v-if="asset.master">
											<v-icon
												:size="20"
												color="green accent-3">
												check
											</v-icon>
											<span
												class="caption green--text text--accent-3"
												style="top: -1px; left: -2px; position: relative;">
												Master
											</span>
										</span>
									</div>
									<div class="dynamic-col text-right"
										:style="{
											'min-width': asset_col_widths.size + 'px',
											'max-width': asset_col_widths.size + 'px'
										}">
										{{ asset.size | humanizeBytes1000 }}
									</div>
									<div class="dynamic-col" :style="{ width: 'max-content' }">
										<span class="resume-item"
											v-for="(item, index) in asset.asset_resume"
											:key="'resume' + index">
											{{ item }}
										</span>
									</div>
								</div>
								<v-card class="background darken-1">
									<v-card-text class="px-2 pb-1 pt-0">
										<div v-if="asset.filepath">
											<span v-if="asset.filepath.indexOf('/') === 0">
												<router-link
													target="_blank"
													:to="{
														name: 'Filesystem',
														query: {
															path: maestroToUNC(asset.filepath)
														}
													}">
													{{ maestroToUNC(asset.filepath) }}
												</router-link>
											</span>
											<span v-else>{{ asset.filepath }}</span>
										</div>
										<div>
											<a
												:href="`${behive_url}dashboard/materials/${asset_id}/`"
												target="_blank">
												BeHive
											</a>
										</div>
										<div
											class="subheading"
											:class="{
												'warning--text': computed_data.title.princ.toLowerCase() !== asset.titre.princ.toLowerCase()
											}">
											{{ asset.titre.princ }}
										</div>
										<div
											class="background--text text--lighten-5 pb-2"
											:class="{
												'warning--text text--lighten-2': computed_data.title.princ.toLowerCase() !== asset.titre.princ.toLowerCase()
											}">
											{{ asset.titre.sec }}
										</div>
										<table>
											<tbody>
												<tr v-if="asset.duration">
													<td>
														<span class="mr-3 background--text text--lighten-5">
															Durée
														</span>
													</td>
													<td>
														{{ asset.duration }}
													</td>
												</tr>
												<tr v-if="asset.codec ||
															asset.fmt_film ||
															asset.profile ||
															asset.fps ||
															asset.resolution">
													<td>
														<span class="mr-3 background--text text--lighten-5">
															Image
														</span>
													</td>
													<td>
														<span
															v-if="asset.codec"
															class="mr-2">
															{{ asset.codec }}
														</span>
														<span
															v-if="asset.fmt_film"
															class="mr-2">
															{{ asset.fmt_film }}
														</span>
														<span
															v-if="asset.profile"
															class="mr-2">
															{{ asset.profile }}
														</span>
														<span
															v-if="asset.fps"
															class="mr-2">
															{{ asset.fps }}fps
														</span>
														<span
															v-if="asset.resolution"
															class="mr-2">
															{{ asset.resolution }}
														</span>
													</td>
												</tr>
												<tr v-if="asset.audio.length">
													<td>
														<span class="mr-3 background--text text--lighten-5">
															Son
														</span>
													</td>
													<td>
														<span
															v-for="(audio, index) in asset.audio"
															:key="'audio' + index"
															class="mr-2">
															{{ audio }}
														</span>
													</td>
												</tr>
												<tr v-if="asset.subtitle.length">
													<td>
														<span class="mr-3 background--text text--lighten-5">
															Sous-titres
														</span>
													</td>
													<td>
														<span
															v-for="(subtitle, index) in asset.subtitle"
															:key="'subtitle' + index"
															class="mr-2">
															{{ subtitle }}
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</v-card-text>
								</v-card>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-flex>

					<v-flex xs6 class="pl-1">
						<div class="headline mb-1">
							FABRICATIONS
						</div>
						<div
							v-for="fab in computed_data.fabrications"
							:key="fab.idÒ"
							class="mb-2 pa-2 suifa-fab elevation-4"
							:class="{ 'selected-fab': selected_fab === fab.id }"
							@click="toggleFab(fab)">
							<v-container fluid class="pa-0">
								<v-layout>
									<v-flex grow>
										<span
											class="title d-inline-block text-center"
											style="min-width: 28px; max-width: 28px">
											{{ fab.id }}
										</span>
										<span class="subheading">
											{{ fab.prestation.code }}
										</span>
									</v-flex>
									<v-flex shrink>
										<span class="background--text text--lighten-5">
											délai:
										</span>
										{{ fab.due_date | formatDateNoTime }}
									</v-flex>
								</v-layout>
								<v-layout class="pb-2 offset-right">
									<v-flex xs12>
										<div class="background--text text--lighten-5">
											{{ fab.prestation.label }}
										</div>
									</v-flex>
								</v-layout>
								<v-layout class="offset-right">
									<v-flex shrink>
										<span class="background--text text--lighten-5">
											Zone:
										</span>
										{{ fab.zone_fab }}
									</v-flex>
								</v-layout>
								<v-layout class="offset-right">
									<v-flex shrink>
										<span class="background--text text--lighten-5">
											Statut:
										</span>
										{{ fab.status }}
									</v-flex>
									<v-flex shrink class="pl-3">
										{{ fab.unite_prestation.count || 0 }}
										{{ fab.unite_prestation.unit }}
									</v-flex>
								</v-layout>
								<v-layout class="offset-right">
									<v-flex shrink>
										<span class="background--text text--lighten-5">
											Fait le:
										</span>
										{{ fab.end_date | formatDateNoTime }}
									</v-flex>
									<v-flex shrink class="pl-3">
										<span class="background--text text--lighten-5">
											par:
										</span>
										{{ fab.user.login }}
										<span class="caption">
											{{ fab.user.name | capitalize }}
										</span>
									</v-flex>
									<v-spacer></v-spacer>
									<v-flex shrink>
										<span class="background--text text--lighten-5">
											Temps passé:
										</span>
										{{ fab.spent_time | formatDateDuration }}
									</v-flex>
								</v-layout>
							</v-container>
						</div>
					</v-flex>
				</v-layout>
			</div>

		</v-container>
	</v-container>
</template>

<script>
import AceJsonViewer from '@/components/ace_json_viewer.vue'
const NUM_OF_RE = /^\d{7}$/
export default {
	components: {
		AceJsonViewer
	},
	data () {
		return {
			num_of: null,
			input_message: '',
			loading_of: false,
			details_of: null,
			computed_data: null,
			selected_fab: null,
			behive_url: window.appConfig._$ou3iju,
			asset_col_widths: {
				type_sup: 0,
				norme: 0,
				size: 0
			}
		}
	},
	computed: {
		is_detail_page () {
			return this.$route.name === 'Suifa OF'
		}
	},
	watch: {
		num_of () {
			this.details_of = null
			this.computed_data = null
			this.updateRoute()
			this.getAssetsFromOF()
		}
	},
	methods: {
		updateRoute () {
			if (!this.is_detail_page) return
			if (NUM_OF_RE.test(this.num_of)) {
				this.$router.replace({
					name: this.$route.name,
					query: { id: this.num_of }
				}).catch(() => {})
			} else {
				this.$router.replace({
					name: this.$route.name
				}).catch(() => {})
			}
		},
		maestroToUNC (maestro_path) {
			return this.$paths.maestroToUNC(maestro_path)
		},
		async getAssetsFromOF () {
			if (!NUM_OF_RE.test(this.num_of)) return
			this.input_message = `Récuperation de l'OF`
			try {
				this.loading_of = true
				let response = await this.$ApiNexus.suifa_of_info(this.num_of)
				response.data.assets = []
				this.details_of = response.data
				let elements = new Set()
				response.data.elements.map(element => {
					elements.add(`suifa-${element.mat_id}`)
				})
				this.input_message = `Récuperation des assets de l'OF`
				for (const element of elements) {
					try {
						let response = await this.$ApiNexus.suifa_asset_info(element)
						this.details_of.assets.push(response.data)
					} catch (error) {
						this.$Toaster({
							title: `Erreur lors de la reccupération de l'asset ${element}`,
							content: error.message,
							type: 'error',
							loading: false,
							timeout: 0
						})
					}
				}
				this.input_message = ''
				this.loading_of = false
				this.computeSuifaData(this.details_of)
			} catch (error) {
				console.log('getAssetsFromOF error', error)
				this.input_message = ''
				this.$Toaster({
					title: `Erreur lors de la reccupération de l'of ${this.num_of}`,
					content: error.message,
					type: 'error',
					loading: false,
					timeout: 0
				})
				this.loading_of = false
			}
		},
		computeSuifaData (of_details) {
			let computed = {
				of: {
					id: of_details.ordre_fab_id,
					status: of_details.etat_of.lib_etat_of
				},
				commande: {
					id: of_details.commande.commande_id,
					status: of_details.commande.etat_cde.lib_etat_cde
				},
				cdc: {
					login: of_details.commande.suiveur.nom_login,
					name: `${of_details.commande.suiveur.prenom} ${of_details.commande.suiveur.nom}`
				},
				title: {
					princ: of_details.titre.titre_princ,
					sec: of_details.titre.titre_sec,
					id: of_details.titre.titre_id
				},
				creation_date: of_details.commande.creation_date,
				due_date: of_details.delai_of,
				customer: this.$commons.deepGet(of_details, 'commande.client.t_libelle', ''),
				assets: {},
				fabrications: []
			}
			for (const asset of of_details.assets) {
				let audio = new Set()
				let audioLanguageIds = new Set()
				for (const tk of asset.piste_son || []) {
					let langId = this.$commons.deepGet(tk, 'langue.langue_id', '')
					if (langId) audioLanguageIds.add(langId)
					let lang = this.$commons.deepGet(tk, 'langue.code_langue', '')
					let mix = this.$commons.deepGet(tk, 'type_son.code_type_son', '')
					let label = []
					if (lang) label.push(lang)
					if (mix) label.push(mix)
					if (label.length) audio.add(label.join(' '))
				}
				let subtitle = new Set()
				for (const sub of asset.sous_titrage || []) {
					let lang = this.$commons.deepGet(sub, 'langue.code_langue', '')
					if (lang) subtitle.add(lang)
				}
				let assetResume = asset.asset_resume
					.split('] [')
					.map(item => item.replace(/\[|\]/g, ''))

				let duration = this.$commons.deepGet(asset, 'mam_data.duration_general', '')
				if (duration) {
					duration = this.$time.secondsToHMS(duration)
				} else if (asset.duree_enreg) {
					duration = asset.duree_enreg || ' T '
					duration = duration.split('T')[1]
				}

				computed.assets[asset.mat_id] = {
					proprio: asset.t_aux_proprio.t_libelle,
					size: asset.asset_size,
					master: asset.master_indic,
					upload_name: asset.upload_name,
					filepath: asset.filepath,
					ingest_date: asset.ingest_date,
					asset_resume: assetResume,
					duration: duration,
					codec: this.$commons.deepGet(asset, 'codec.codec_lib', ''),
					titre: {
						princ: asset.titre.titre_princ,
						sec: asset.titre.titre_sec
					},
					fmt_film: this.$commons.deepGet(asset, 'fmt_film.lib_fmt_film', ''),
					profile: this.$commons.deepGet(asset, 'profile.profile_lib', ''),
					fps: this.$commons.deepGet(asset, 'standard.nb_imag_sec', ''),
					norme: {
						code: this.$commons.deepGet(asset, 'mise_norme.code_mise_norme', ''),
						label: this.$commons.deepGet(asset, 'mise_norme.lib_mise_norme', '')
					},
					type_sup: {
						code: asset.type_sup.code_type_sup,
						label: asset.type_sup.lib_type_sup
					},
					audio: Array.from(audio),
					audio_language_ids: Array.from(audioLanguageIds),
					subtitle: Array.from(subtitle),
					ref_materiel: asset.ref_materiel,
					resolution: this.$commons.deepGet(asset, 'resolution.resolution_lib', ''),
					type_pgm: {
						code: asset.programme.type_prgm.code_type_prgm,
						label: asset.programme.type_prgm.lib_type_prgm
					},
					source_of_fab: [],
					record_of_fab: []
				}
			}
			for (const element of of_details.elements) {
				if (element.lib_nature_elt === 'Source') {
					computed.assets[`suifa-${element.mat_id}`].source_of_fab.push(element.fab_id)
				} else if (element.lib_nature_elt === 'Record') {
					computed.assets[`suifa-${element.mat_id}`].record_of_fab.push(element.fab_id)
				}
			}
			for (const fab of of_details.fabrications) {
				let fabSources = []
				let fabRecords = []
				for (const element of of_details.elements) {
					if (element.fab_id === fab.fab_id) {
						if (element.lib_nature_elt === 'Source') {
							fabSources.push(`suifa-${element.mat_id}`)
						} else if (element.lib_nature_elt === 'Record') {
							fabRecords.push(`suifa-${element.mat_id}`)
						}
					}
				}
				computed.fabrications.push({
					id: fab.fab_id,
					zone_fab: this.$commons.deepGet(fab, 'zonefab.lib_zonefab', ''),
					sources: fabSources,
					records: fabRecords,
					unite_prestation: {
						count: fab.nb_unite_realisee,
						unit: this.$commons.deepGet(fab, 'unite_prestation.lib_unite_prest', '')
					},
					type_prestation: {
						code: fab.type_prestation.code_type_prestation,
						label: fab.type_prestation.lib_type_prestation
					},
					user: {
						login: fab.utilisateur.nom_login,
						name: `${fab.utilisateur.prenom} ${fab.utilisateur.nom}`
					},
					prestation: {
						code: fab.prestation_commune.code_prestation,
						label: fab.prestation_commune.lib_prestation
					},
					end_date: fab.date_fin_fab,
					due_date: fab.delai_fab,
					status: fab.etat_fab.lib_etat_fab,
					spent_time: fab.tps_passe
				})
			}
			this.calculateAssetColsWidths(computed.assets)
			this.computed_data = computed
		},
		toggleFab (fab) {
			if (this.selected_fab === fab.id) {
				this.selected_fab = null
				return
			}
			this.selected_fab = fab.id
		},
		computeAssetIOClass (asset) {
			let isSrc = false
			let isRec = false
			if (asset.source_of_fab.indexOf(this.selected_fab) > -1) isSrc = true
			if (asset.record_of_fab.indexOf(this.selected_fab) > -1) isRec = true
			if (isSrc && isRec) return 'asset-src-and-rec'
			if (isSrc) return 'asset-src'
			if (isRec) return 'asset-rec'
		},
		calculateAssetColsWidths (assets) {
			let widths = {
				type_sup: 0,
				norme: 0,
				size: 0
			}
			// Create temp div to mesure text
			const tempDiv = document.createElement('div')
			tempDiv.style.position = 'absolute'
			tempDiv.style.visibility = 'hidden'
			tempDiv.style.whiteSpace = 'nowrap'
			document.body.appendChild(tempDiv)
			for (const mat_id in assets) {
				let asset = assets[mat_id]
				tempDiv.textContent = asset.type_sup.code
				widths.type_sup = Math.max(widths.type_sup, tempDiv.offsetWidth)
				tempDiv.textContent = asset.norme.code
				widths.norme = Math.max(widths.norme, tempDiv.offsetWidth)
				tempDiv.textContent = this.$options.filters.humanizeBytes1000(asset.size)
				widths.size = Math.max(widths.size, tempDiv.offsetWidth)
			}
			document.body.removeChild(tempDiv)
			// add padding
			this.asset_col_widths = {
				type_sup: widths.type_sup + 8,
				norme: widths.norme + 8,
				size: widths.size + 8
			}
		},
		emitAssets () {
			let assetsSelected = []
			for (const assetId in this.computed_data.assets) {
				let asset = this.computed_data.assets[assetId]
				if (asset.source_of_fab.indexOf(this.selected_fab) > -1) {
					if (asset.filepath) {
						assetsSelected.push(asset)
					}
				}
			}
			this.$emit('assets-selected', assetsSelected)
		}
	},
	mounted () {
		if (this.is_detail_page) {
			if (this.$route.query.id) {
				this.num_of = this.$route.query.id
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>.v-content__wrap
	background-color: blue
.resume-item
	padding: 0 4px
	margin-right: 4px
	border-radius: 4px
	border: 1px solid var(--v-background-lighten1)
	background-color: rgba(255, 255, 255, 0.15)

.align-top
	vertical-align: top

.suifa-fab
	padding: 4px
	border-radius: 4px
	cursor: pointer
	border: 1px solid var(--v-background-lighten2)
	background-color: var(--v-background-darken1)
	&:hover
		border: 1px solid var(--v-primary-base)
	.offset-right
		padding-left: 32px

.selected-fab
	border: 1px solid var(--v-primary-base)
	box-shadow: none

.assets-panels
	box-shadow: none
>>>.asset-panel
	border: 1px solid var(--v-background-lighten2) !important
	background-color: var(--v-background-darken1) !important
	margin-bottom: 8px
	border-radius: 4px
	.v-expansion-panel__header
		padding: 4px 8px
		min-height: 34px

.asset-src
	border: 1px solid var(--v-blue-base) !important
.asset-rec
	border: 1px solid var(--v-green-accent3) !important
.asset-src-and-rec
	outline-offset: 2px
	outline: 1px solid var(--v-blue-base) !important
	border: 1px solid var(--v-green-accent3) !important

.expansion-header-dynamic
	display: flex
	align-items: center
	flex-wrap: wrap

.dynamic-col
	padding: 0 4px
	overflow: hidden
	text-overflow: ellipsis

a:before
	content: '\2771\2771 '
</style>



// WEBPACK FOOTER //
// src/pages/tools/suifa_of/suifa_of.vue